import { createSharedPathnamesNavigation } from 'next-intl/navigation'
import { locales } from './constants/locales'

export type Locales = (typeof locales)[number]
export const defaultLocale = 'en' as Locales
export const localePrefix = 'as-needed' // Default

export const { Link, redirect, usePathname, useRouter } =
  createSharedPathnamesNavigation({ locales, localePrefix })
